export const selectedCardShadowStyles =
    'shadow-(--progress-glow-shadow-lg) group-hover:shadow-(--progress-glow-shadow-xl)';
export const progressChipLabelStyles =
    'text-[0.7rem] font-semibold text-(--text-light) font-(family-name:--secondary-font) ' +
    'tracking-[0.01em] transition-colors duration-200 ease-[ease]';
export const controlDescriptionStyles =
    'font-(family-name:--primary-font) text-[0.85rem] text-(--text-muted) mt-0.5 leading-[1.4]';
export const controlLabelStyles =
    'font-(family-name:--primary-font) text-[0.925rem] font-medium leading-normal ' +
    'text-(--input-neumorphic-text) select-none cursor-pointer transition-colors duration-200';
export const truncatedChipLabelStyles = 'whitespace-nowrap overflow-hidden text-ellipsis max-w-35';
export const navigationToggleLinesStyles = 'flex h-4.5 w-4.5 flex-col items-start justify-between';
export const dataCollectionFooterInfoStyles = 'text-center text-xs text-gray-500 dark:text-gray-400';
export const checkableControlRootStateStyles =
    '[&:has([data-state=checked])_[data-slot=label]]:text-(--input-neumorphic-text) ' +
    '[&:has([data-state=checked])_[data-slot=label]]:font-semibold ' +
    '[&:has([data-disabled])_[data-slot=label]]:cursor-not-allowed ' +
    '[&:has([data-disabled])_[data-slot=label]]:text-(--text-muted) ' +
    '[&:has([data-disabled])_[data-slot=description]]:cursor-not-allowed ' +
    '[&:has([data-disabled])_[data-slot=description]]:text-(--input-neumorphic-disabled-border)';
export const checkableControlDisabledStyles =
    'data-disabled:cursor-not-allowed data-disabled:opacity-[0.55] ' +
    'data-disabled:bg-(image:--input-neumorphic-disabled-bg)! ' +
    'data-disabled:border-(--input-neumorphic-disabled-border)! ' +
    'data-disabled:shadow-(--input-neumorphic-disabled-shadow)!';
export const softPanelSurfaceStyles =
    'rounded-2xl border-[0.063rem] border-(--control-border-neumorphic) bg-(image:--panel-bg-soft)';
export const progressChipControlStyles =
    'px-3 py-[0.45rem] rounded-[1.687rem] border border-transparent bg-transparent cursor-pointer ' +
    'whitespace-nowrap';
export const selectIndicatorIconStyles =
    'size-5 shrink-0 text-(--text-light) transition-[color,transform] duration-300 ease-[ease] ' +
    'group-hover:text-(--text-strong) group-aria-expanded:rotate-180';
export const selectTriggerStyles =
    'flex min-h-11 w-full min-w-0 items-center justify-between gap-2.5 rounded-full! border ' +
    'border-(--control-border-neumorphic)! bg-(image:--control-bg-neumorphic) px-5 py-3.5 ' +
    'font-(family-name:--primary-font) text-[0.925rem] font-medium tracking-[-0.01em] ' +
    'text-(--input-neumorphic-text) outline-none shadow-(--panel-shadow-soft-inset)! transition-colors ' +
    'duration-300 hover:not-disabled:border-(--control-border-neumorphic-hover)! ' +
    'hover:not-disabled:bg-(image:--control-bg-neumorphic-hover) ' +
    'focus-within:border-(--input-neumorphic-focus-border)! ' +
    'focus-within:shadow-(--input-neumorphic-focus-shadow)! ' +
    'aria-expanded:border-(--input-neumorphic-focus-border)! ' +
    'aria-expanded:shadow-(--input-neumorphic-focus-shadow)! ' +
    'aria-invalid:border-(--input-neumorphic-error-border)! ' +
    'aria-invalid:shadow-(--input-neumorphic-error-shadow)! ' +
    'aria-invalid:focus-within:border-(--input-neumorphic-error-border-focus)! ' +
    'aria-invalid:focus-within:shadow-(--input-neumorphic-error-shadow-focus)! ' +
    'aria-invalid:aria-expanded:border-(--input-neumorphic-error-border-focus)! ' +
    'aria-invalid:aria-expanded:shadow-(--input-neumorphic-error-shadow-focus)! ' +
    'disabled:cursor-not-allowed disabled:opacity-[0.55] disabled:text-(--text-muted)! ' +
    'disabled:bg-(image:--input-neumorphic-disabled-bg)! ' +
    'disabled:border-(--input-neumorphic-disabled-border)! ' +
    'disabled:shadow-(--input-neumorphic-disabled-shadow)!';
export const selectValueStyles = 'font-medium tracking-[-0.01em] text-(--input-neumorphic-text)';
export const selectPlaceholderStyles = 'font-normal tracking-[0.01em] text-(--text-muted)';
export const selectContentStyles =
    'z-50 mt-2 min-w-full rounded-[1.25rem] border border-(--white-alpha-70)! ' +
    'bg-(image:--surface-select-menu-bg) px-1.5 py-2 outline-none ring-0 ' +
    'data-[state=closed]:animate-none! shadow-[0_0.5rem_2rem_-0.375rem_rgba(0,0,0,0.1)]';
export const selectViewportStyles =
    'scheme-light scrollbar-thin [scrollbar-color:var(--gray-alpha-30)_transparent] ' +
    '[&::-webkit-scrollbar]:w-1.5 [&::-webkit-scrollbar]:bg-transparent ' +
    '[&::-webkit-scrollbar-button]:hidden [&::-webkit-scrollbar-track]:bg-transparent ' +
    '[&::-webkit-scrollbar-thumb]:rounded-full [&::-webkit-scrollbar-thumb]:bg-(--gray-alpha-30) ' +
    '[&::-webkit-scrollbar-thumb:hover]:bg-(--gray-alpha-50)';
export const selectGroupLabelStyles = 'px-6 py-2 text-xs font-semibold uppercase tracking-wider text-(--text-muted)';
export const selectItemStyles =
    'flex cursor-pointer items-center gap-2.5 overflow-hidden rounded-full px-6 py-3 before:hidden! ' +
    'font-(family-name:--primary-font) text-[0.9rem] tracking-[-0.01em] text-(--accent-solid) ' +
    'transition-colors duration-200 ease-[ease] [&+&]:mt-1 hover:bg-(image:--surface-select-bg) ' +
    'hover:text-(--input-neumorphic-text)! hover:shadow-(--surface-select-shadow) ' +
    'data-highlighted:bg-(image:--surface-select-bg) data-highlighted:text-(--input-neumorphic-text)! ' +
    'data-highlighted:shadow-(--surface-select-shadow) ' +
    'data-[state=checked]:bg-(image:--surface-select-item-active-bg) data-[state=checked]:font-semibold ' +
    'data-[state=checked]:text-(--input-neumorphic-text) ' +
    'data-[state=checked]:shadow-(--surface-select-item-active-shadow)';
export const selectItemTrailingIconStyles =
    'size-5 shrink-0 text-(--accent-solid) group-data-[state=checked]:text-(--input-neumorphic-text)';
